import * as yup from "yup";
import { toast } from "react-toastify";
import request from "Utils/Helper/Request";
import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Btn, H4, P, Image } from "Core/Components";
import { Form, FormGroup, Input, Label, Row, Col, Container } from "reactstrap";
// import logoWhite from 'assets/images/logo/logo.png';
// import logoDark from 'assets/images/logo/logo_dark.png';

const RegisterForm = () => {
  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);

  //** Default Values */
  const defaultValues = {
    name: "",
    email: "",
    phone: "",
    password: "",
    terms: false,
  };

  // ** Register Schema
  const registerSchema = yup.object().shape({
    name: yup.string().required("Name is a required field"),
    email: yup.string().required("Email is a required field"),
    phone: yup.string().required("Phone Number is a required field"),
    password: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    terms: yup.bool().oneOf([true], "Please accept the terms and conditions"),
  });

  //** UseForm */
  const {
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues, resolver: yupResolver(registerSchema) });

  //** Handle Onsubmit */
  const onSubmit = (values) => {
    setIsLoading(true);
    request(`${process.env.REACT_APP_MTN_BASE_API_URL}/auth/register`, {
      method: "POST",
      body: {
        name: values.name,
        email: values.email,
        phone: values.phone,
        password: values.password,
      },
    })
      .then((response) => {
        if (response && response.status) {
          reset();
          setIsLoading(false);
          history(`${process.env.PUBLIC_URL}/auth/login`);
          toast.success(response.message, {
            position: "top-right",
          });
        } else {
          setIsLoading(false);
          toast.error(response.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        if (error.response.status > 200) {
          setIsLoading(false);
          toast.error(error.response.payload.message, {
            position: "top-right",
          });
        }
      });
  };
  return (
    <Fragment>
      <section>
        <Container fluid={true} className="p-0">
          <div className="login-card">
            <div>
              <div>
                <Link
                  className={`logo text-center fs-4 fw-bold`}
                  to={process.env.PUBLIC_URL}
                >
                  {/* <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'looginpage' }} />
                  <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: 'looginpage' }} /> */}
                  HML Aggregator Portal
                </Link>
              </div>
              <div className="login-main">
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className="theme-form login-form"
                >
                  <div className="text-center">
                    <H4>Create your account</H4>
                    <P>Enter your personal details to create account</P>
                  </div>
                  <FormGroup>
                    <Label className="col-form-label m-0 pt-0">Your Name</Label>
                    <Controller
                      name="name"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Input
                          type="text"
                          name={field.name}
                          id={field.name}
                          placeholder="Name"
                          value={field.value}
                          onChange={field.onChange}
                          invalid={fieldState.invalid}
                        />
                      )}
                    />
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label m-0 pt-0">
                      Email Address
                    </Label>
                    <Controller
                      name="email"
                      control={control}
                      rules={{ required: true, pattern: /^\S+@\S+$/i }}
                      render={({ field, fieldState }) => (
                        <Input
                          type="email"
                          name={field.name}
                          id={field.name}
                          placeholder="Email"
                          value={field.value}
                          onChange={field.onChange}
                          invalid={fieldState.invalid}
                        />
                      )}
                    />
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label m-0 pt-0">
                      Phone Number
                    </Label>
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Input
                          type="text"
                          name={field.name}
                          id={field.name}
                          placeholder="Phone Nmuber"
                          value={field.value}
                          onChange={field.onChange}
                          invalid={fieldState.invalid}
                        />
                      )}
                    />
                    {errors.phone && (
                      <span className="text-danger">
                        {errors.phone.message}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label m-0 pt-0">Password</Label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field, fieldState }) => (
                        <div className="position-relative">
                          <Input
                            type={togglePassword ? "text" : "password"}
                            name={field.name}
                            id={field.name}
                            value={field.value}
                            className="form-control"
                            onChange={field.onChange}
                            placeholder="*********"
                            invalid={fieldState.invalid}
                          />
                          <div
                            className="show-hide"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            <span
                              className={togglePassword ? "" : "show"}
                            ></span>
                          </div>
                        </div>
                      )}
                    />
                    {errors.password && (
                      <span className="text-danger">
                        {errors.password.message}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup className="m-0">
                    <div className="checkbox">
                      <input
                        id="checkbox1"
                        type="checkbox"
                        {...register("terms", { required: true })}
                      />
                      <Label className="text-muted" for="checkbox1">
                        Agree with <span>Privacy Policy</span>
                      </Label>
                    </div>
                    {errors.terms && (
                      <span className="text-danger">
                        {errors.terms.message}
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Btn
                      attrBtn={{
                        disabled: isSubmitting || isLoading,
                        className: "d-block w-100",
                        color: "primary",
                        type: "submit",
                      }}
                    >
                      Create Account{" "}
                      {(isSubmitting || isLoading) && (
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      )}
                    </Btn>
                  </FormGroup>
                  <P attrPara={{ className: "mb-0 text-center" }}>
                    Already have an account?
                    <Link
                      className="ms-2"
                      to={`${process.env.PUBLIC_URL}/auth/login`}
                    >
                      Sign in
                    </Link>
                  </P>
                </Form>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </Fragment>
  );
};

export default RegisterForm;
